import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/** 
 * Custom validator that behaves like the built-in 'maxLength' validator, 
 * but marks the control as invalid when the length exceeds the maximum limit.
 * 
 * Additionally, this validator marks the control as touched when the length 
 * exceeds the accepted maximum length, ensuring that the user receives immediate feedback.
 */
export function customMaxLengthValidator(maxLength: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (control.value && control.value.length > maxLength) {
            control.markAsTouched(); // Mark the control as touched
            return { maxlength: true }; // Mark as invalid if exceeds maxlength
        }
        return null; // No errors
    };
}